import { NgModule } from "@angular/core";
import {  DepositECheckAddPage } from "./deposit-e-check-add";
import { CommonModule } from "@angular/common";
import { IonicModule } from "@ionic/angular";
import { ReactiveFormsModule } from "@angular/forms";
import { ComponentsModule } from "src/app/components/components.module";


@NgModule({
  declarations: [DepositECheckAddPage],
  imports: [
    CommonModule,
    IonicModule,
    ReactiveFormsModule,
    ComponentsModule,
  ],
})
export class DepositECheckAddPageModule {}
